module.exports = __webpack_public_path__ + "img/btn_join.e95ac222.png";